export default "__VITE_ASSET__DDLWJqje__"